// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardTile.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import classnames from 'classnames';
import { getOr, isNil } from 'lodash/fp';
import UiState from 'logic/Izenda.UiState';
import { propTypes as ObservablePropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import LoadingIndicator from 'share/components/controls/Izenda.LoadingIndicator';
import AppContext from 'share/enhancers/Izenda.AppContext';
import connect from 'share/enhancers/Izenda.Connect';
import BlankDashboardTile from './BlankTile/Izenda.BlankDashboardTile';
import DashboardTileBody from './Izenda.DashboardTileBody';
import DashboardTileHeader from './Izenda.DashboardTileHeader';

let tileLoader = {};

@connect({
  context: {
    childContextTypes: AppContext.loaderShape,
    getChildContext(props) {
      const dashboardPart = props.dashboardPart;
      if (!tileLoader[dashboardPart.id]) {
        tileLoader[dashboardPart.id] = AppContext.createLoaderContext();
      }
      return tileLoader[dashboardPart.id];
    }
  }
})
export default class DashboardTile extends Component {
  static propTypes = {
    store: ObservablePropTypes.observableObject.isRequired,
    dashboardPart: ObservablePropTypes.observableObject.isRequired,
    dashboardDetail: ObservablePropTypes.observableObject,
    fullScreen: PropTypes.bool,
    viewMode: PropTypes.bool
  };

  getDisableViewReportMessage(key) {
    const localization = this.props.localization;
    if (!isNil(key)) {
      if (key == 'NO_PERMISSION')
        return localization.getText('COMMON_MESSAGES_NOPERMISSION_VIEWREPORT');
      if (key == 'UNAVAILABLE_DATA_SOURCE')
        return localization.getText('DATA_MODEL_UNAVAILABLE_DATA_SOURCE');
    }
    
    return localization.getText('COMMON_MESSAGES_GENERIC_ERROR')
  };

  render() {
    const props = this.props;
    const {
      dashboardDetail = {},
      dashboardPart,
      fullScreen,
      viewMode,
      store,
      printingMode,
      editDashboard,
      setCurrentDesignerFieldStore,
      clearFieldDetails
    } = props;
    const { type, disableViewReport, disableViewReportMessageKey, filterRequired } = dashboardPart;
    const dashboard = getOr({}, 'dashboard', dashboardDetail);
    const accessPriority = dashboard.accessPriority;

    if (isNil(type) && UiState.isMobile) return null;

    const header = !fullScreen && !printingMode && dashboard.displayDashboardTileHeader && (
      <DashboardTileHeader
        editDashboard={editDashboard}
        store={store}
        dashboardPart={dashboardPart}
        dashboardDetail={dashboardDetail}
        viewMode={viewMode}
        presentationMode={props.presentationMode}
      />
    );

    const bodyClass = classnames('u_fullSize izenda-DashboardTile-Content-Body', {
      u_paddingAll: !viewMode,
      u_paddingLeftRight: viewMode,
      'izenda-DashboardTile-Content-Body-fixed': viewMode && !store.dashboardDesignerMode.isFullscreen,
      u_table: disableViewReport
    });

    const tileBody = (
      <div className='u_fullSize '>
        <div className={bodyClass}>
          {!disableViewReport ? (
            <DashboardTileBody
              filterRequired={filterRequired}
              dashboardPart={dashboardPart}
              viewMode={viewMode}
              store={store}
              printingMode={printingMode}
              finishedRender={props.finishedRender}
              accessPriority={accessPriority}
              setCurrentDesignerFieldStore={setCurrentDesignerFieldStore}
              clearFieldDetails={clearFieldDetails}
            />
          ) : (
            <div className='u_tableCell u_alignMiddle u_textCenter'>
              <div>
                <span className='icon-info-circled u_LargeIcon' />
              </div>
              <span className='white-space-pre-line'>
                {this.getDisableViewReportMessage(disableViewReportMessageKey)}
              </span>
            </div>
          )}
        </div>
      </div>
    );

    const blankBody = (
      <BlankDashboardTile
        disabled={!editDashboard}
        dashboardDetail={dashboardDetail}
        dashboardPart={dashboardPart}
        store={store}
        viewMode={viewMode}
      />
    );

    const body = isNil(type) ? blankBody : tileBody;
    // Default style for dashboard tile in presentation mode
    const dashboardTileStyle = props.presentationMode ? props.dashboardTileStyle : {};

    return (
      <div className='u_fullSize izenda-DashboardTile' style={dashboardTileStyle}>
        <div className='u_fullSize izenda-DashboardTile-Content u-posRelative'>
          {header}
          {body}
          <LoadingIndicator />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Izenda.DashboardTile.js